<template>
  <div class="text-container">
    <div class="header">
      <div class="color-line1"></div>
      <div class="color-line2"></div>
      <p class="total">相关结果约 <span>{{ total }}</span> 条</p>
    </div>
    <div class="text">
      <div v-if="total > 0">
        <div
          class="info-box box-item"
          v-for="(item, ind) in searchList"
          :key="ind"
          >
          <div class="box-header" v-if="item.isShow">
            <p class="title">{{ item.name }}</p>
            <p class="more" v-if="!item.showMore" @click="handleShowMore(item)">查看更多 <img src="../../assets/image/home-inform-icon2.png" alt=""></p>
          </div>
          <div class="box-content">
            <info v-if="item.id==='info'" :list="infoList" ></info>
            <teacher-model v-if="item.id==='teacher'" :list="teacherList"></teacher-model>
            <class-model v-if="item.id==='class'" :list="classList"></class-model>
          </div>
        </div>
      </div>

      <div class="no-data" v-if="total === 0">
        <img src="../../assets/image/pending-search.png" alt="">
        <p>很抱歉！未能搜索到您想要的内容</p>
        <div class="left">
          <p>建议您：</p>
          <p>1.看看输入的文字是否有误</p>
          <p>2.去掉可能不必要的词或条件</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Info from './components/info'
import TeacherModel from './components/teacher'
import ClassModel from './components/class'
import { informationEs, teacherEs, queryClassEs } from '@/api/search'
import { EventBus } from '@/libs/eventBus'
export default {
  components: {
    Info,
    TeacherModel,
    ClassModel
  },
  data() {
    return {
      totalList: [],
      total: '',
      searchList: [
        { id: 'info', name: '资讯', showMore: false, list: [], pageInfo: { pageSize: 20, total: 0, current: 1 } },
        { id: 'teacher', name: '名师风采', showMore: false, list: [], pageInfo: { pageSize: 20, total: 0, current: 1 } },
        { id: 'class', name: '面授培训', showMore: false, list: [], pageInfo: { pageSize: 20, total: 0, current: 1 } }
      ],
      infoList: [],
      teacherList: [],
      classList: []
    }
  },
  computed: {
    name() {
      return this.$route.query.searchValue
    }
  },
  watch: {
    // name(val) {
    //   if (val) {
    //     console.log('4')
    //     this.getList(val, 1, 3)
    //   }
    // }
  },
  created() {
    if (this.name && Number(this.total) < 1) {
      console.log('3')
      this.getList(this.name, 1, 3)
    }
    // 解决重复点击搜索无法调用接口的问题
    if (Number(this.total) < 1) {
      EventBus.$on('searchValue', (value) => {
        if (value) {
          console.log('bus')
          this.getList(value, 1, 3)
        }
      })
    }
  },
  methods: {
    // 展示更多
    handleShowMore(item) {
      this.$router.push({
        path: '/search/detail',
        query: {
          searchValue: this.name,
          name: item.id
        }
      })
    },
    sum(arr) {
      let s = 0
      arr.forEach(function (value) {
        s += value
      })
      return s
    },
   async getList(name, page, limit) {
      this.totalList = []
      this.classList = []
      this.infoList = []
      this.teacherList = []
      this.total =
      await this.getInfo(name, page, limit)
      await this.getTeacher(name, page, limit)
      await this.getClass(name, page, limit)
      this.total = this.sum(this.totalList)
      console.log('total', this.total)
    },
    // 获取资讯列表
   async getInfo(name, page, limit) {
     await informationEs({
        name,
        page,
        limit
      }).then(res => {
        const { code, data } = res
        console.log('info', data, this.totalList)
        if (code === 0 && data) {
          this.totalList.push(Number(data.totalElements))
          this.searchList[0].pageInfo = {
            total: Number(data.totalElements)
          }
          if (data.content.length > 0) {
            this.infoList = data.content
            this.searchList[0].isShow = true
          } else {
            this.searchList[0].isShow = false
          }
        }
      })
    },
    // 获取名师列表
   async getTeacher(name, page, limit) {
    await teacherEs({
        name,
        page,
        limit
      }).then(res => {
        const { code, data } = res
        if (code === 0 && data) {
          this.totalList.push(Number(data.totalElements))
          this.searchList[1].pageInfo = {
            total: Number(data.totalElements)
          }
          if (data.content.length > 0) {
            this.searchList[1].isShow = true
            this.teacherList = data.content
          } else {
            this.searchList[1].isShow = false
          }
        }
      })
    },
    // 获取面授培训列表
   async getClass(name, page, limit) {
    await queryClassEs({
        name,
        page,
        limit
      }).then(res => {
        const { code, data } = res
        console.log('class', data)
        if (code === 0 && data) {
          this.totalList.push(Number(data.totalElements))
          this.searchList[2].pageInfo = {
            total: Number(data.totalElements)
          }
          if (data.content.length > 0) {
            this.searchList[2].isShow = true
            this.classList = data.content
            console.log('class', this.searchList[2], this.classList)
          } else {
            this.searchList[2].isShow = false
          }
        }
      })
    }
  },
  // 避免重复触发event bus 需要在页面销毁时移除监听
  destroyed() {
    EventBus.$off('searchValue')
  }
}
</script>

<style lang="scss" scoped>
.text-container {
  max-width: 1300px;
  margin: 30px auto 40px;
  background-color: #fff;
  box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
  padding: 0 0 140px;
  .header {
    height: 54px;
    padding: 0 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: linear-gradient(0deg, #ffffff 0%, #eaeaea 100%);
    position: relative;
    box-sizing: border-box;
    .color-line1 {
      position: absolute;
      box-sizing: border-box;
      width: calc(100% - 36px);
      height: 2px;
      background: rgba($color: #085dc8, $alpha: 0.35);
      top: 0;
      left: 0;
      margin: 0 18px;
    }
    .color-line2 {
      position: absolute;
      width: 128px;
      height: 4px;
      background: #ff4e4e;
      top: 0;
      left: 18px;
    }
    .total {
      color: #333;
      font-size: 14px;
      font-weight: bold;
      span {
        color: #FF4E4E;
      }
    }
  }
  .box-item {
    margin-top: 20px;
    padding: 0 58px;
    .box-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px solid rgba(8, 93, 200, .3);
      .title {
        width: 70px;
        color: #333;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        position: relative;
        &::before {
          content: '·';
          display: inline;
          font-size: 20px;
          color: #D00D0D;
        }
        &::after {
          content: '';
          display: inline-block;
          width: 70px;
          height: 4px;
          background-color: #FF4E4E;
          border-radius: 2px;
          position: absolute;
          bottom: -2px;
          left: 0;
          text-align: center;
        }
      }
      .more {
        color: #333;
        font-size: 14px;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          height: 18px;
          margin-left: 5px;
        }
      }
    }
  }
  .no-data {
    width: 304px;
    margin: 90px auto 0;
    text-align: center;
    img {
      margin-bottom: 30px;
    }
    p {
      color: #999;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }
    .left {
      text-align: left;
      margin: 15px 40px;
    }
  }
  ::v-deep .el-pagination {
    text-align: center;
    margin-top: 50px;
    .el-pagination__total {
      color: #333;
    }
    .el-input__inner, .el-pager li.active {
      color: #333;
      background-color: rgba(10, 101, 219, 0.22);
      border: 1px solid #0753B6;
    }
    .el-pager li.active {
      color: #0753B6;
      border-radius: 5px;
    }
    span {
      color: #333;
    }
  }
}
</style>
